type RuntimeConfig = {
  API_BASE_URL?: string;
  GRAPHQL_BACKEND?: string;
};

function readWindowRuntimeConfig(): RuntimeConfig {
  try {
    const w = window as any;
    const cfg = w?.__RUNTIME_CONFIG__;
    if (cfg && typeof cfg === 'object') return cfg as RuntimeConfig;
  } catch {}
  return {};
}

/**
 * Reads configuration with priority:
 * 1) window.__RUNTIME_CONFIG__ (runtime, S3/CloudFront)
 * 2) process.env.REACT_APP_* (build-time, CRA)
 */
export function getRuntimeConfig() {
  const runtime = typeof window !== 'undefined' ? readWindowRuntimeConfig() : {};

  const apiBaseUrl =
    (runtime.API_BASE_URL ?? '').toString().trim() || (process.env.REACT_APP_API_BASE_URL || '').trim();

  const graphqlBackend =
    (runtime.GRAPHQL_BACKEND ?? '').toString().trim() || (process.env.REACT_APP_GRAPHQL_BACKEND || '').trim();

  return {
    apiBaseUrl,
    graphqlBackend,
  };
}
